import { RefObject, useEffect, useRef } from 'react';
import type { TimelineDay } from './types';
import { DAY_STEP } from './helpers';

const buildRangeKey = (days: TimelineDay[]): string =>
  days.length === 0 ? '' : `${days[0].date}_${days[days.length - 1].date}`;

export const useAutoScrollToToday = (
  todayIndex: number,
  days: TimelineDay[],
  scrollableRef: RefObject<HTMLElement>,
): void => {
  const lastRangeKeyRef = useRef('');

  useEffect(() => {
    const node = scrollableRef.current;
    if (!node || days.length === 0) return;
    const rangeKey = buildRangeKey(days);
    if (rangeKey === lastRangeKeyRef.current) return;

    const rafId = requestAnimationFrame(() => {
      const maxScrollLeft = Math.max(0, node.scrollWidth - node.clientWidth);
      const offset = Math.max(todayIndex, 0) * DAY_STEP;
      node.scrollLeft = Math.min(offset, maxScrollLeft);
      lastRangeKeyRef.current = rangeKey;
    });
    return () => cancelAnimationFrame(rafId);
  }, [days, todayIndex, scrollableRef]);
};
